import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  sublabel,
  id,
  className = ''
}: CtaButtonProps) {
  return <div className={`mx-auto w-full max-w-xl text-center ${className}`} data-id="element-68" data-mp="ck9cdgfx3e9o">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-plum px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_12px_30px_-8px_rgba(91,42,134,0.65)] transition-[transform,background-color] duration-150 ease-out hover:bg-plum-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/60 sm:text-lg" data-id="element-69" data-mp="qkk7wws69h16">
        <CheckCircle2Icon className="h-6 w-6 shrink-0 text-gold" aria-hidden="true" data-id="element-70" data-mp="198yy5huo0r0x" />
        <span data-id="element-71" data-mp="15b1523xrxks9">{label}</span>
      </a>
      {sublabel && <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-72" data-mp="35xo0oxojy8ky">{sublabel}</p>}
    </div>;
}